import React from "react";
import { Plural } from "@lingui/macro";
import { Badge, BodyLarge } from "@conserveit/blocks";
import { PriorityBadge } from "../PriorityBadge";
import { GroupHeadingProps } from "../../utils";
import { useAnalysis } from "../../../../context/analysis";
import {
  Bar,
  Left,
  Right,
  IconWrapper,
  TodayCountWrapper,
  SubduedBodyLarge,
} from "../GroupHeading.styles";

const PriorityGroupHeading: React.FunctionComponent<GroupHeadingProps> = ({
  instance,
  insightsCount,
  equipsCount,
  unassociatedEquipsCount,
  insightsCountToday,
}) => {
  if (!instance || instance.priority === undefined) return null;

  const [{ viewMode }] = useAnalysis();

  const headingText =
    instance.priority === 0
      ? "Unprioritised"
      : viewMode === "insights"
      ? "Prioritised"
      : `Priority ${instance.priority}`;

  return (
    <Bar>
      <Left>
        <IconWrapper>
          <PriorityBadge priority={instance.priority} />
        </IconWrapper>
        <BodyLarge as="div">
          {headingText}{" "}
          <SubduedBodyLarge as="span">({insightsCount})</SubduedBodyLarge>
          <TodayCountWrapper>
            <Plural
              value={equipsCount}
              one={`${unassociatedEquipsCount} of ${equipsCount} Equip Unassociated`}
              other={`${unassociatedEquipsCount} of ${equipsCount} Equips Unassociated`}
            />
          </TodayCountWrapper>
        </BodyLarge>
      </Left>
      <Right>
        {insightsCountToday > 0 && <Badge>{insightsCountToday} new</Badge>}
      </Right>
    </Bar>
  );
};

export default PriorityGroupHeading;
